export default {
  page_title: 'Universal promo codes',
  badge: 'One step to set up',
  title: 'Turn on promo codes for your Olo locations',
  body: "Promo codes run through your Olo integration, so Olo needs to switch them on before you can create them in Thanx. Send your Olo representative the note below — we've pre-filled it for you.",
  step_1_title: 'Copy the note below',
  step_1_body:
    'It already includes your Thanx Client ID, so your rep has everything they need.',
  step_2_title: 'Email it to your Olo representative',
  step_2_body_prefix: 'CC',
  step_2_body_suffix: 'so our team knows the request is in flight.',
  step_3_title: "We'll take it from there",
  step_3_body:
    'Once Olo confirms, the Thanx success team is notified and promo codes unlock on this page — no further action needed.',
  note_title: 'Note to your Olo rep',
  copy: 'Copy',
  copy_success: 'Note copied to clipboard',
  copy_error: 'Could not copy the note. Please copy it manually.',
  note_prefix:
    "We'd like to use Thanx as our Olo coupon code provider. My Thanx Client ID is",
  note_suffix:
    "I've CC'd the Thanx success team — please let them know once this is completed.",
  feature_title: 'Single use and static codes',
  feature_body:
    'Create exportable one-time use codes in batch or set a static code, either of which can be shared broadly across channels and promotions.',
}
